module.exports = __webpack_public_path__ + "../resources/images/calendar_drophint-c6713d8aa8f43d63794032c36016b87c.svg";